import { render, staticRenderFns } from "./ShiftDataSidebar.vue?vue&type=template&id=13a8555e&scoped=true"
import script from "./ShiftDataSidebar.vue?vue&type=script&lang=ts"
export * from "./ShiftDataSidebar.vue?vue&type=script&lang=ts"
import style0 from "./ShiftDataSidebar.vue?vue&type=style&index=0&id=13a8555e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a8555e",
  null
  
)

export default component.exports